import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import { DateTool, ClassName} from "mgToolsKit";
import { MGSiteButton } from 'mgUiKit';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetFreebetsComponent';

class Freebets extends React.Component {
    constructor(props) {
        super(props);
        this.goToPage = this.goToPage.bind(this);
        this.openTicket = this.openTicket.bind(this);
    }

    goToPage(freebet){
        location.href = freebet.Url;
    }

    openTicket(url, e) {
        if(AppSettings.device != "desktop"){
            window.open(url, "_blank");
        }
        else{
            var r = 600, i = 600;
            var o = "Stampa ticket";
            var e = (screen.width - r) / 2;
            var u = (screen.height - i) / 2;
            window.open(url, "ticket", "left=" + e + ",top=" + u + ",width=" + r + ",height=" + i + ",scrollbars=yes,resizable=no,status=yes");
        }
        return false;
    }

    renderScadenza(){
        var freebet = this.props.data;
        var expire = parseInt(freebet.ValidTo);
        if(isNaN(expire) || expire <=0){
            return "";
        }
        var retScadenza = "";
        var date = new DateTool(expire);
        var expireString = "al " +date.getDate()
        if(date.isToday()){
            expireString = "a oggi";
        }
        if(date.isTomorrow()){
            expireString = "a domani";
        }
        return (
            <span onClick={this.goToPage.bind(this, freebet)} className="mg-bonus-data">Valido fino <strong>{expireString}</strong></span>
        );
    }

    renderWinning(){
        var freebet = this.props.data;
        var winningType = parseInt(freebet.WinningType);
        if(isNaN(winningType) || winningType <=0){
            return "";
        }
        
        var formatEuro = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
        });
        var retMaxWinning = "";
        /**
            Fixed = 1,
            Winning = 2,
            NetWinning = 3,
         */
        var freebetWinning = 0;
        switch (winningType) {
            case 1: //Fixed
                freebetWinning = formatEuro.format(freebet.MaxWinning);
                break;
            case 2:  // Winning
                var maxWinning = parseInt(freebet.MaxWinning);
                var oddsCart = 0;
                // Se è presente il modulo scommesse
                if(typeof _betSlip != "undefined"){
                    oddsCart = _betSlip.odds;
                }

                if (!isNaN(maxWinning) && maxWinning > 0) {
                    if(oddsCart > 0){
                        freebetWinning = freebet.Amount * oddsCart;
                         //verifico se la vincita supera la massima
                        if (freebetWinning > maxWinning) freebetWinning = formatEuro.format(maxWinning);
                    }
                    else{
                        freebetWinning = "Vincita massima " + formatEuro.format(maxWinning);
                    }
                }
                else {
                    //vincita ticket
                    freebetWinning = freebet.Amount * oddsCart;
                    if (freebetWinning > 0) {
                        freebetWinning = formatEuro.format(freebetWinning); 
                    }
                    else {
                        freebetWinning = 'Vincita ticket';
                    }
                }
                break;
            case 3: // NetWinning
                var maxWinning = parseInt(freebet.MaxWinning);
                var oddsCart = 0;
                // Se è presente il modulo scommesse
                if(typeof _betSlip != "undefined"){
                    oddsCart = _betSlip.odds;
                }
                if (!isNaN(maxWinning) && maxWinning > 0) {
                    if(oddsCart > 0){
                        //verifico se la vincita supera la massima
                        freebetWinning = freebet.Amount * oddsCart - freebet.Amount;
                        // if(freebetWinning < 0){
                        //     freebetWinning = 0;
                        // }
                        if (freebetWinning > maxWinning){
                            freebetWinning = maxWinning;
                        } 
                        freebetWinning = formatEuro.format(freebetWinning);
                    }
                    else{
                        freebetWinning = 'Vincita massima ' + formatEuro.format(maxWinning);
                    }
                }
                else {
                    //verifico se la vincita supera la massima
                    if(oddsCart > 0){
                        freebetWinning = freebet.Amount * oddsCart - freebet.Amount;
                        freebetWinning = formatEuro.format(freebetWinning);
                    }
                    else{
                        freebetWinning = 'Vincita netta ticket';
                    }
                }
                break;
        }
        // retMaxWinning = '<span class="mg-bonus-data">Vincita promozione <strong>' 
        //     + freebetWinning + '</strong></span>';
        // return retMaxWinning;

        return (
            <span onClick={this.goToPage.bind(this, freebet)} className="mg-bonus-data">Vincita promozione 
                <strong>
                {freebetWinning}
                </strong>
            </span>
        )
    }


    renderLimitazioni(){
        var freebet = this.props.data;

        let scope = freebet.Scope;
        if(freebet.State == 8){
            scope = freebet.TicketScope;
        }

        var retHtml = [];

        if(typeof scope.AmountTarget != "undefined" && scope.AmountTarget > 0){
            var formatEuro = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR',
            });
            
            retHtml.push(
                <li key="amountTarget">Importo da giocare: <strong>{formatEuro.format(scope.AmountTarget)}</strong></li>
            );
        }

        if (scope.OutcomeNumberFrom > 0 || scope.OutcomeNumberTo > 0) {
            if (scope.OutcomeNumberFrom > 0 && scope.OutcomeNumberTo > 0 && scope.OutcomeNumberTo < 50) {
                if (scope.OutcomeNumberFrom == 1 && scope.OutcomeNumberTo == 1) {
                    retHtml.push(
                        <li key="outcome">Gioca una singola</li>
                    );
                }
                else {
                    let label = "selezione";
                    if(scope.OutcomeNumberFrom > 1){
                        label = "selezioni";
                    }
                    retHtml.push(
                        <li key="outcome">Gioca min. <strong> {scope.OutcomeNumberFrom}</strong> {label} fino a <strong> {scope.OutcomeNumberTo}</strong></li>
                    );
                }
            }
            else {
                if (scope.OutcomeNumberFrom > 0) {
                    if (scope.OutcomeNumberFrom == 1) {
                        retHtml.push(
                            <li key="outcome">Gioca una singola</li>
                        );
                    }
                    else {
                        let label = "selezione";
                        if(scope.OutcomeNumberFrom > 1){
                            label = "selezioni";
                        }
                        retHtml.push(
                            <li key="outcome">Gioca min. <strong>{scope.OutcomeNumberFrom}</strong> {label}</li>
                        );
                    }
                }
                else {
                    let label = "selezione";
                    if(scope.OutcomeNumberTo > 1){
                        label = "selezioni";
                    }
                    retHtml.push(
                        <li key="outcome">Gioca max. <strong>{scope.OutcomeNumberTo}</strong> {label}</li>
                    );
                }
            }
        }

        //let singleOutcomeOddsFrom = scope.SingleOutcomeOddsFrom / 100;
        //let singleOutcomeOddsTo = scope.SingleOutcomeOddsTo / 100;

        let singleOutcomeOddsFrom = parseFloat(scope.SingleOutcomeOddsFrom);
        if(isNaN(singleOutcomeOddsFrom)){
            singleOutcomeOddsFrom = 1;
        }
        // else{
        //     singleOutcomeOddsFrom = singleOutcomeOddsFrom / 100;
        // }
        
        let singleOutcomeOddsTo = parseFloat(scope.SingleOutcomeOddsTo);
        if(isNaN(singleOutcomeOddsTo)){
            singleOutcomeOddsTo = 1;
        }
        // else{
        //     singleOutcomeOddsTo = singleOutcomeOddsTo / 100;
        // }

        if (singleOutcomeOddsFrom > 1 || (singleOutcomeOddsTo > 1 && singleOutcomeOddsTo < 10000)) {
            if (singleOutcomeOddsFrom > 1 && singleOutcomeOddsTo > 1 && singleOutcomeOddsTo < 10000) {
                retHtml.push(
                    <li key="singleoutcome">Ogni selezione deve avere una quota min. di <strong>{singleOutcomeOddsFrom}</strong> fino a <strong>{singleOutcomeOddsTo}</strong></li>
                );
            }
            else {
                if (singleOutcomeOddsFrom > 1) {
                    retHtml.push(
                        <li key="singleoutcome">Ogni selezione deve avere una quota min. <strong>{singleOutcomeOddsFrom}</strong></li>
                    );
                }
                else {
                    retHtml.push(
                        <li key="singleoutcome">Ogni selezione deve avere una quota max. <strong>{singleOutcomeOddsTo}</strong></li>
                    );
                }
            }
        }
        
        // let totalOddsFrom = scope.TotalOddsFrom/100;
        // let totalOddsTo = scope.TotalOddsTo/100;
        
        let totalOddsFrom = parseFloat(scope.TotalOddsFrom);
        if(isNaN(totalOddsFrom)){
            totalOddsFrom = 1;
        }
        // else{
        //     totalOddsFrom = totalOddsFrom / 100;
        // }
        
        let totalOddsTo = parseFloat(scope.TotalOddsTo);
        if(isNaN(totalOddsTo)){
            totalOddsTo = 1;
        }
        // else{
        //     totalOddsTo = totalOddsTo / 100;
        // }

        if (totalOddsFrom > 1 || (totalOddsTo > 1 && totalOddsTo < 10000)) {
            if (totalOddsFrom > 1 && totalOddsTo > 1 && totalOddsTo < 10000) {
                retHtml.push(
                    <li key="totalodds">Quota totale min. di <strong>{totalOddsFrom}</strong> fino a <strong>{totalOddsTo}</strong></li>
                    );
            }
            else {
                if (totalOddsFrom > 1) {
                    retHtml.push(
                         <li key="totalodds"> Quota totale min. <strong>{totalOddsFrom}</strong></li>
                    );
                }
                else {
                    retHtml.push(
                        <li key="totalodds">Quota totale max. <strong>{totalOddsTo}</strong></li>
                    );
                }
            }
        }

        let label = "Limitazioni";

        if(retHtml.length > 0){
            return (
                <>
                <span className="mg-fb-label">{label}</span>
                <ul className="mg-dati-coupon-moreinfo-details">
                    {retHtml}
                </ul>
                </>
            );
        }
        else{
            return "";
        }
    }

    renderInfoAggiuntive(){
        var freebet = this.props.data;
        var id  = "info-dettagli-" + freebet.Code;
        return (
            <div className="mg-dati-coupon-moreinfo">
                <input type="checkbox" id={id} className="toggle-info" />
                <label htmlFor={id} className="toggle-label">Informazioni e dettagli</label>
                <div className="mg-dati-coupon-moreinfo-opened">
                   
                    <p className="mg-long-description">{freebet.LongDescription}</p>
                    {this.renderLimitazioni()}
                </div>
            </div>
        );
    }

    render() {
        var formatEuro = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
        });
        var freebet = this.props.data
        var _className  = new Array();
        _className.push("mg-user-widget");
        _className.push("mg-bonus-freebet");
        if(freebet.wagering != null){
            _className.push("mg-freebet-wagering");
        }

        //
        if(freebet.State != 2){
            _className.push("mg-freebet-" + freebet.c.n.toLowerCase());
        }
        
        let _label = "";
        switch(freebet.c.id){
            case 1:
                _label = "Classica";
                break;
            case 3:
                _label = "Maggiorata";
                break;
            case 2:
                _label = "cashback freeBet"
                break;
            case 4:
                _label = "win freeBet"
                break;
            case 5:
                _label = "opt-in freeBet"
                break;
        }

        let _assignedDescription = "";
        if(freebet.assigned != null){
            let _categoryName = "";
            switch(freebet.assigned.category){
                case 1:
                    _categoryName = "";
                    break;
                case 3:
                    _categoryName = "Sbloccata";
                    break;
                case 2:
                    _categoryName = "Assicurata";
                    break;
                case 4:
                    _categoryName = "Premio";
                    break;
                case 5:
                    _categoryName = "Missione vinta";
                    break;
            }
            if(_categoryName != ""){
                let ticketLink  = "HtmlBetTicketPrint.aspx?idpuntata=" + freebet.assigned.ticket;
                _assignedDescription =
                    <div className="mg-freebet-actived">
                        <a href="#" onClick={this.openTicket.bind(this,ticketLink)}>
                            {_categoryName}  sulla scommessa {freebet.assigned.ticketIB}
                        </a>
                    </div>;
            }
        }

        // Gestione url freebet
        //var urlfreebet = "/scommesse-sportive";
        // var freebetContainer = 
        //     '<i class="mg-icon-freebet"></i>'
        //     + '<div class="mg-bonus-wrap">' 
        //         + '<a href="' + freebet.Url + '" class="mg-play-game">' 
        //                 + '<span class="mg-user-widget-titolo">'
        //                     + freebet.Description
        //                 + '</span>' 
        //         + '</a>'
        //         + _assignedDescription
        //         //+ '<span class="mg-fb-type">' + _label + '</span>'
        //         + this.renderWinning()
        //         + this.renderScadenza()
        //     + '</div>'
        //     + '<span class="mg-bonus-importo--valore">' + formatEuro.format(freebet.Amount) +'</span>';
        
        // 
        return (
            <div className={ClassName(_className)}>
                <div className="mg-dati-ecoupon">
                    <i className="mg-icon-freebet"  onClick={this.goToPage.bind(this, freebet)}></i>
                    <div className="mg-bonus-wrap">
                        <a href={freebet.Url} className="mg-play-game">
                            <span className="mg-user-widget-titolo">
                                {freebet.Description}
                            </span>
                        </a>
                        
                        {_assignedDescription}
                        {this.renderWinning()}
                        {this.renderScadenza()}
                    </div>
                    <span className="mg-bonus-importo--valore">{formatEuro.format(freebet.Amount)}</span>
                </div>
                {(freebet.ImageUrl != null && freebet.ImageUrl != "") ?
                    <img alt="Immagine coupon" className="mg-image-promotion" src={freebet.ImageUrl } />
                : ""}
                
                {(freebet.PromoUrl != null && freebet.PromoUrl != "") ?
                    <MGSiteButton
                        title={AppSettings['label'].FreebetRaisedLabel}                       
                        class="mg-link-promotion"
                        label={AppSettings['label'].FreebetRaisedLabel}
                        disabled={false}
                        primary={true}
                        isButton={true}
                        fullWidth={true}
                        href={freebet.PromoUrl} 
                    />              
                : ""}
                {this.renderInfoAggiuntive()}
            </div>
        );
    }
}

Freebets.displayName = componentName;

// PropTypes validation
Freebets.propTypes = {
    data: PropTypes.object.isRequired
};

// default props
Freebets.defaultProps = {
};

export default Freebets;